var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 18.3335C3.33203 14.6516 6.3168 11.6668 9.9987 11.6668C13.6806 11.6668 16.6654 14.6516 16.6654 18.3335H14.9987C14.9987 15.5721 12.7601 13.3335 9.9987 13.3335C7.23727 13.3335 4.9987 15.5721 4.9987 18.3335H3.33203ZM9.9987 10.8335C7.2362 10.8335 4.9987 8.596 4.9987 5.8335C4.9987 3.071 7.2362 0.833496 9.9987 0.833496C12.7612 0.833496 14.9987 3.071 14.9987 5.8335C14.9987 8.596 12.7612 10.8335 9.9987 10.8335ZM9.9987 9.16683C11.8404 9.16683 13.332 7.67516 13.332 5.8335C13.332 3.99183 11.8404 2.50016 9.9987 2.50016C8.15703 2.50016 6.66536 3.99183 6.66536 5.8335C6.66536 7.67516 8.15703 9.16683 9.9987 9.16683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLine);
export default __webpack_public_path__ + "static/media/user-line.3464b08fa4324a244d11648e611335e4.svg";
export { ForwardRef as ReactComponent };